import { FormControl } from '@material-ui/core'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import FormHelperText from '@material-ui/core/FormHelperText'
import Radio from '@material-ui/core/Radio'
import RadioGroup from '@material-ui/core/RadioGroup'
import { useField } from 'formik'
import React from 'react'
import getBooleanValue from '../../shared/helpers/getBooleanValue'

type RadioGroupProps = {
  disabled: boolean
  name: string
  options?: Array<any>
  onChange?: (...args: any[]) => void
  booleans?: boolean
}

const ValidatedRadioGroup = ({ disabled, name, onChange, options, booleans }: RadioGroupProps) => {
  const [field, meta] = useField(name)

  const error = !!(meta.error && meta.touched)
  const helperText = error ? meta.error : null
  const value = booleans ? getBooleanValue(meta.value) : `${meta.value}`

  return (
    <FormControl component="fieldset" error={error} disabled={disabled}>
      <RadioGroup value={value} onChange={onChange ? onChange : field.onChange}>
        {options?.map((option, index) => {
          return (
            <FormControlLabel
              key={index}
              value={option.value}
              control={
                <Radio name={name} size="small" disabled={disabled} color={option.color ? option.color : 'primary'} />
              }
              label={option.label}
            />
          )
        })}
      </RadioGroup>
      <FormHelperText>{helperText}</FormHelperText>
    </FormControl>
  )
}

export default ValidatedRadioGroup
